import Insight from "../insightClass";
import React from "react";
import { insight38Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight066 = new Insight(
  "26 September 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight38Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-09-26)",
  "",
  `France’s outgoing government awarded a 1.5 GW offshore wind project off Normandy to a consortium led by TotalEnergies. The state set a tariff of €66/MWh, around 47 per cent higher than the nearby 2023 tender. The project is expected to deliver about 6 TWh per year, powering roughly one million households.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-09-26)</h1>
    <h2></h2>
    <p className="article-date">26 September 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. France awards its biggest offshore wind farm to TotalEnergies (with RWE
      set to exit)
    </h3>
    <p>
      France’s outgoing government awarded a 1.5 GW offshore wind project off
      Normandy to a consortium led by TotalEnergies. The state set a tariff of
      €66/MWh, around 47 per cent higher than the nearby 2023 tender. The
      project is expected to deliver about 6 TWh per year, powering roughly one
      million households. TotalEnergies anticipates final investment decision in
      2029 and first power by 2033. In a twist, consortium partner RWE has
      requested to exit, citing strategic reasons. TotalEnergies has confirmed
      it can continue alone while also seeking a new partner. The award came
      during political turbulence following the government’s collapse and before
      publication of a revised multi-year energy plan (PPE), raising questions
      about continuity in France’s auction schedule. This is TotalEnergies’
      first French offshore win, expanding a portfolio more established in the
      UK and Germany. The government explained the higher tariff as a function
      of construction costs now running about 50 per cent higher than in
      previous rounds. France remains far behind its 45 GW by 2050 target, with
      only around 1.5 GW operating today.
    </p>
    <p>WeBridge Insights:</p>
    <p>
      The €66/MWh strike highlights Europe’s new pricing norm: higher but still
      investable with indexation and long-dated offtake. RWE’s withdrawal is a
      risk, but replacement partners should emerge, with supply chain strength
      and financing appetite decisive. Critical watchpoints include certainty of
      grid connections, availability of French port infrastructure for XXL
      components, and clarity once the delayed PPE is published. For OEMs, the
      long lead time aligns with order book gaps post-2028, while procurement is
      likely to be staged to reduce commodity exposure. For UK stakeholders, the
      outcome offers a benchmark for higher CfD pricing in future allocation
      rounds.
    </p>
    <h3>2. France’s Oleron auction fails to attract a single bid</h3>
    <p>
      France’s offshore wind programme suffered a setback as the 1 GW Oleron
      site auction closed without any developer bids. Despite the government’s
      push to accelerate deployment, prevailing inflation, permitting
      complexity, and grid concerns appear to have outweighed potential returns.
      The site, located in an environmentally sensitive area, may also have been
      judged less commercially attractive than alternatives in the UK, Germany,
      and the Netherlands. The contrast with the successful Normandy tender
      underscores the importance of auction design and perceived bankability.
      Officials have acknowledged the failure and signalled that terms may need
      to be revisited, including risk allocation and tariff structures. The
      immediate effect is likely to be a delay in France’s auction pipeline,
      with potential knock-on impacts on the national 2050 target.
    </p>

    <p>WeBridge Insights:</p>
    <p>
      A failed auction indicates a mismatch between government ambition and
      market appetite. Developers are unwilling to pursue marginal sites without
      stronger risk sharing or higher remuneration. France will likely
      recalibrate by adjusting indexation terms or revising site conditions. For
      financiers, the outcome shows the need to model auction failure scenarios
      explicitly. For supply chain actors, fewer awarded projects could mean
      volatility in forward workload. The wider lesson is that credible auction
      design is as critical as capacity targets in driving investment and
      ensuring delivery.
    </p>
    <h3>
      3. Italy grants permit for floating wind investigations off Sardinia
    </h3>
    <p>
      Italy has authorised a developer to undertake geophysical, geotechnical,
      and environmental surveys off the coast of Sardinia to assess the
      feasibility of a floating offshore wind project. The permit allows two
      years of detailed investigations to establish seabed conditions, marine
      habitats, and metocean parameters. Floating wind is particularly suited to
      the Mediterranean, where waters are generally too deep for fixed-bottom
      foundations. Italy is seeking to diversify its energy mix and reduce
      dependence on imports, with floating wind identified as a strategic
      opportunity. The Mediterranean market has gigawatt-scale potential but
      faces technical challenges such as harsher wave conditions, cable design
      complexity, and environmental sensitivities. This permit is a preliminary
      but essential step towards unlocking commercial projects in the region.
    </p>
    <p>WeBridge Insights:</p>
    <p>
      Data quality gathered during this stage will determine future bankability.
      Survey results influence foundation design, mooring system reliability,
      and cable routing. Floating projects in the Mediterranean face higher
      engineering demands, making robust studies even more vital. Technology
      choice will be important, with semi-submersible, spar, and barge platforms
      all in contention. Regional collaboration could also emerge, linking
      projects off Sardinia, Corsica, and mainland Italy through shared
      infrastructure. For supply chain players, the opportunity lies in
      providing moorings, fabrication, and marine surveys to a region only
      beginning to scale but with substantial long-term potential.
    </p>
    <h3>4. Dutch minister defends revised offshore wind targets</h3>
    <p>
      The Dutch climate minister has defended the government’s decision to
      adjust and delay elements of its offshore wind programme, citing soaring
      costs, grid constraints, and local opposition. The Netherlands had set
      some of the most ambitious targets in Europe, aiming for 21 GW by 2030,
      but officials now concede that certain milestones will slip. The minister
      stressed that the revised pathway balances affordability, system
      stability, and public acceptance. Industry participants have voiced
      concern that uncertainty over auction cadence could dampen investment
      flows, while local resistance to nearshore sites and environmental
      concerns have also complicated delivery. Although tenders will continue,
      the announcement highlights the tension between high ambition and
      practical feasibility.
    </p>
    <p>WeBridge Insights:</p>
    <p>
      This adjustment is a reminder that even mature markets can recalibrate
      targets when faced with economic and social pressures. Developers must
      factor in the risk of slippage in national pipelines. For permitted
      projects, scarcity could enhance value, while speculative opportunities
      may struggle to attract funding. Investors should anticipate higher costs
      of capital where demand signals are less certain. For the wider European
      market, the Dutch move underscores the importance of robust grid expansion
      and stakeholder engagement as enablers of offshore delivery. Contractual
      structures with phased commitments and flexibility will be essential for
      developers navigating policy uncertainty.
    </p>
    <h3>
      5. Aviation group Avincis moves into offshore wind with helicopter
      acquisition
    </h3>
    <p>
      Aviation company Avincis has expanded into offshore wind by acquiring KN
      Helicopters of Denmark, adding four large helicopters to its fleet. The
      firm, already active in the UK, Spain, Portugal, and Sweden, intends to
      deploy the aircraft for crew transfer, logistics, and emergency response
      at offshore wind projects. Helicopters have long been used in offshore oil
      and gas, but their application in offshore wind is still relatively
      limited. As wind farms move further offshore and weather risks increase,
      air access is gaining traction as a complement to vessel-based operations.
      Avincis has not yet announced project-specific contracts but has
      positioned the acquisition as part of a broader diversification strategy
      into renewables.
    </p>
    <p>WeBridge Insights:</p>
    <p>
      The move highlights the emergence of aviation logistics as a specialist
      niche in offshore wind. Helicopters can provide resilience against weather
      downtime and enable rapid deployment for urgent repairs, boosting turbine
      availability. For developers, hybrid strategies combining vessel and
      helicopter access may offer cost-effective reliability, particularly in
      commissioning phases or remote sites. Integration with marine operations
      will be critical to achieve efficiencies. For investors, the development
      signals that new service categories are opening, with potential for
      bundled contracts that include both sea and air logistics. This could
      create a high-margin opportunity for providers that can deliver
      integrated, safety-compliant solutions.
    </p>
    <h3>
      6. US court lifts stop-work order on Revolution Wind while probe continues
    </h3>

    <p>
      A US federal court has lifted the stop-work order on Revolution Wind,
      Ørsted’s major offshore project off Rhode Island and Connecticut, allowing
      construction to resume. The order, issued in August by the Trump
      administration, cited national security concerns and halted activity
      despite the project being about 80 per cent complete with 45 of 65
      turbines already installed. The court judged the government’s action
      legally inadequate, noting the severe financial harm caused by delays,
      estimated at over $2 million per day. Work can now restart on turbine
      installation, substations, and cabling, although federal authorities
      continue to investigate the approvals process. The uncertainty has not
      been fully eliminated, but the ruling provides immediate relief to Ørsted
      and its partners.
    </p>
    <p>WeBridge Insights:</p>
    <p>
      The case underscores the fragility of permitting certainty in the US. For
      Ørsted, immediate focus must be on rapid remobilisation of vessels and
      crews to recover schedule and avoid weather-related slippage. For
      financiers, the ongoing investigation highlights residual regulatory risk,
      which may prompt stronger contractual protections such as escrowed
      milestone payments and enhanced force majeure clauses. For developers with
      US exposure, portfolio diversification remains critical to balance higher
      political risk. The ruling also restores short-term confidence across
      supply chains, reducing concerns about stranded assets and vessel idling.
      In the longer term, however, developers will need to build explicit
      policy-risk buffers into business cases to ensure resilience.
    </p>
    <h3>
      7. Iberdrola begins survey campaign for 3 GW offshore project in Australia
    </h3>
    <p>
      Iberdrola has launched a two-year survey programme for a proposed 3 GW
      offshore wind farm off the coast of Australia. The campaign will include
      geophysical, geotechnical, and environmental studies, creating the
      baseline data required for future design, permitting, and financing.
      Australia has identified offshore wind as a key pillar of its energy
      transition, but the market remains at an early stage, with no large
      projects yet under construction. Iberdrola’s investment signals a
      first-mover strategy to shape regulatory frameworks and secure a knowledge
      advantage. Surveys will examine seabed integrity, marine ecosystems, and
      weather conditions, informing decisions on turbine siting and foundation
      technology. Results are expected to guide project design as Australia
      advances towards formal auctions or licensing rounds later this decade.
    </p>
    <p>WeBridge Insights:</p>
    <p>
      By committing resources early, Iberdrola is positioning itself as a leader
      in a promising but challenging market. High-quality data will de-risk
      construction and underpin environmental impact assessments. Australia’s
      deep waters and cyclone exposure demand robust structural design and
      advanced corrosion management, making accurate metocean data vital. For
      global developers, the move demonstrates the value of early presence to
      influence market rules and secure supply chain commitments. For Australia,
      the investment is a vote of confidence likely to accelerate port and grid
      planning. Supply chain participants should see opportunities in surveys,
      mooring technology, and fabrication as the market begins to open.
    </p>

    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
